(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelectorAll('.exitintent__layer').length) {
            return
        }

        document.querySelectorAll('.exitintent__layer .modal-body *[data-dismiss]').forEach((dismissButton) => {
            dismissButton.addEventListener('click', () => {
                new BSN.Modal(dismissButton.closest('.exitintent__layer')).hide()
            })
        })

        document.querySelectorAll('.exitintent__layer').forEach((layer) => {
            const exitintentType = layer.classList.contains('exitintent__layer--successtriggered') ? 'success' : 'default'

            if (!document.getElementById('system-message-container') && exitintentType === 'default') {
                let exitIntentFired = false

                document.addEventListener('mouseout', (e) => {
                    if (exitIntentFired) {
                        return
                    }

                    if (e.toElement != null || e.relatedTarget != null || e.y > 0) {
                        return
                    }

                    exitIntentFired = true

                    new BSN.Modal(layer).show()

                    window.dispatchEvent(new CustomEvent('exitIntentShown'))
                }, false)
            }

            if (document.getElementById('system-message-container') && !document.getElementById('system-message-container').innerText.includes('Wir werden uns so schnell') && exitintentType === 'success') {
                document.getElementById('system-message-container').addEventListener('hidden.bs.modal', () => {
                    new BSN.Modal(layer).show()
                })
            }
        })
    })
}) ()
